export enum FeatureFlags {
  WebexIntegration = "webex-integration",
  ExternalTriggerFlow = "flow-external-trigger",
  PackTopLevelPerformance = "PackTopLevelPerformance",
  ReportingOverview = "reporting-overview",
  MicrosoftGraphReports = "microsoft-graph-reports",
  EmailReport = "FED-AP-EmailPerformanceEndpoints-06072023",
  PdfReport = "FED-AP-PdfPerformanceEndpoints-06282023",
  EventReport = "FED-AP-EventsPerformance-temp-02212023",
  AssessmentReport = "FED-AP-AssessmentPerformanceEndpoints-06282023",
  SurveyReport = "FED-AP-SurveyPerformanceEndpoints-06292023",
  VideoReport = "FED-AP-VideoPerformanceEndpoints-06262023",
  FlowReport = "FED-AP-FlowPerformanceEndpoints-06292023",
  PdfOverviewEndpoints = "FED-AP-PdfPerformanceOverview-07312023",
  VideoPerformanceOverview = "FED-AP-VideoPerformanceOverview-07252023",
  AssessmentPerformanceOverview = "FED-AP-AssessmentPerformanceOverview-07272023",
  SurveyPerformanceOverview = "FED-AP-SurveyPerformanceOverview-07272023",
  EmailPerformanceOverview = "FED-AP-EmailPerformanceOverview-08282023",
  FlowPerformanceOverview = "FED-AP-FlowPerformanceOverview-08282023",
  EventPerformanceOverview = "FED-AP-EventPerformanceOverview-06102024",
  GoogleReports = "FED-AP-GoogleReports-09272023",
  PeopleReports = "FED-AP-PeopleReports-01182023",
  UserPerformance = "FED-AP-UserPerformanceReport-01172024v2",
  TemplatePerformance = "template-performance-report",
  MsGraphGoalReporting = "flow-goals-ms-graph-report",
  MsGraphAutoRemoveUsers = "ms-graph-auto-remove-users",
  SvReportingFilter = "sv-reporting-filter",
  SmtpDirectSend = "smtp-directsend",
  FlowVersioningMigration = "flow-versioning-migration",
  DashboardReports = "dashboard-reports",
  DeleteContentWithDependenciesFeature = "delete-content-with-dependencies",
  LicenseRemoval = "license-removal",
  AwsEncoding = "aws-encoding",
  CommunicationTimezone = "communication-time-zone",
  LicenseGroupsFilter = "license-type-groups-filter",
  FlexiblePriorityDueDate = "flexible-priority-due-date",
  AcquisitionReport = "acquisition-report",
  EmbeddedVideos = "embedded-videos",
  LinkAssetType = "link-asset-type",
  LimitEventRegistration = "limit-event-registration",
  GroupPerformance = "group-performance-report",
  ThreatDefenceAddon = "threat-defence-addon",
  EmbeddedVideoReport = "embedded-videos-report",
  AccountManagedByContacts = "account-managed-by-contacts",
  PhishingCampaignsReport = "phishing-campaigns-report",
  ThreatDefenseReport = "threat-defense-report",
  LinkReport = "link-report",
  MessageReport = "message-report",
  AccountReport = "account-report",
  LinksReport = "links-report",
  PaidPacks = "paid-packs",
  CrediCardProcessing = "credit-card-processing",
  GroupCsvUserImport = "group-csv-user-import",
  GroupCreateCsvUserImport = "group-create-csv-user-import",
  EnableAddOnRequests = "enable-add-on-requests",
  EventNotifications = "event-notifications",
  ThreatDefenceDomains = "threat-defence-domains",
  NotifyUsers = "notify-users",
  EventSorting = "event-sorting",
  MultiRecurrentSessions = "multi-recurrent-sessions",
  OtherPackType = "other-pack-type",
  CopilotReport = "copilot-report",
  MessagesReport = "messages-report",
  PacksAndLicensingReporting = "packs-and-licensing-reporting",
  PacksReport = "packs-report",
  AdditionalPurchase = "additional-purchase",
  ContentScheduling = "content-scheduling",
  AddOnsReport = "add-ons-report",
  BlackList = "black-list",
  SCORM = "scorm-support",
}
